const newsletter = `
# eBL Newsletter 17

## 7 August 2024

### Fragmentarium

- Records for all tablets from Ur have been created, including photographs
  of approximately **5,000** tablets previously loaned to the British Museum and
  now housed in the Iraq Museum. Notable discoveries among them include a
  school colophon model specifying that an apprentice should “crumble” a
  tablet into a container after writing it
  ([U.3018](https://www.ebl.lmu.de/fragmentarium/U.3018)) and a variant version
  of the Sumerian King List
  ([U.33271](https://www.ebl.lmu.de/fragmentarium/U.33271)).
- Folios
  - Notebook IX of G. Smith (Bilinguals) has been added.
  - Folios by Jussi Aro (courtesy of Sanna Aro-Valjus) have been added. They
    contain finished copies of some 50 extispicy texts, mostly Old Babylonian
    manuscripts and Neo-Assyrian extispicy reports.
- The new **Permissions** tab in the text editor allows control over who can
  access an edition. For example, checking \`Restrict it to users with CAIC
  permissions\` limits access to CAIC project members. This enables private
  editing until the editor is ready to publish the edition.
- Editors are kindly requested to add the label \`@colophon\` to their editions,
  since this enables the automatic retrieval of all colophons in the database.

### Tools

- A new display of signs in sign search has been implemented: Now similar
  beginnings and endings are suggested for Neo-Babylonian and Neo-Assyrian
  scripts. See also the new section “Sign Order” in
  [About > Signs](https://www.ebl.lmu.de/about/signs).

### Corpus

- New text added: III.13,
  [Macranthropic Hymn to Ninurta](https://www.ebl.lmu.de/corpus/L/3/13)
  (with two new manuscripts).
- The eBL Lab notes in last year’s *Kaskal* have been published
  (see [here](https://www.torrossa.com/it/resources/an/5774281)).`

export default newsletter
